import ilustrasiEmail from "assets/email.svg"
import "pages/CekEmail.css";
import { useLocation } from "react-router-dom";

function CekEmail() {
  const location = useLocation();

  return (
    <>
      <div className="wrapper">
        <div className="row justify-content-md-center text-center">
          <div className="col-12">
            <div className="p-5">
              <div className="m-4">
                <h3>Silakan Cek Email Anda</h3>
              </div>
              <div>
                <img
                  className="ilustration-email mt-4"
                  src={ilustrasiEmail}
                  alt="Langkah-langkah Penggunaan Sistem"
                />
              </div>
              <div className="text-center m-4">
                <p>Tautan detail status kendaraan sudah berhasil dikirimkan ke email <b>{location.state.submitFormData.email}</b>.
                Klik tautan tersebut untuk melihat.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CekEmail;
